import Loader from "@/components/loader/Loader.vue";

export default {
  name: "Care",
  components: {
    Loader
  },
  data() {
    return {
      loading: true,
      saving: false,
      careSettings: {
        dailyPlan: [
          {
            title: 'Medications',
            name: 'medications',
            enabled: true,
            actions: [
              { id: 4054, title: 'Add SD Setup / Change', name: 'addSDSetup', enabled: true },
              { id: 4001, title: 'Add Medication', name: 'addMedication', enabled: true },
              { id: 4002, title: 'Add PRN medication', name: 'addPRNMedication', enabled: true },
              { id: 4019, title: 'Add Cream', name: 'addCream', enabled: true },
              { id: 4027, title: 'Add Insulin', name: 'addInsulin', enabled: true },
            ],
          },
          {
            title: 'Ad-hoc Actions',
            name: 'adHocActions',
            enabled: true,
            actions: [
              {
                title: 'Soft drink',
                name: 'softDrink',
                enabled: true,
                actions: [
                  { id: 2052, title: 'Reminisce', name: 'reminisce', enabled: true },
                  { id: 2001, title: 'Stayed in room', name: 'stayedInRoom', enabled: true },
                  { id: 2002, title: 'Returned to room', name: 'returnedToRoom', enabled: true },
                ]
              },
              {
                title: 'Bell',
                name: 'bell',
                enabled: true,
                actions: [
                  { id: 1002, title: 'Loose bowels', name: 'looseBowels', enabled: true },
                  { id: 1004, title: 'Wet clothes', name: 'wetClothes', enabled: true },
                  { id: 1005, title: 'Soiled clothes', name: 'soiledClothes', enabled: true },
                ]
              },
              {
                title: 'Fall',
                name: 'fall',
                enabled: true,
                actions: [
                  { id: 4036, title: 'In pain', name: 'inPain', enabled: true },
                  { id: 4008, title: 'Sick', name: 'sick', enabled: true },
                  { id: 4003, title: 'Call doctor', name: 'callDoctor', enabled: true },
                  { id: 4004, title: 'Ambulance', name: 'ambulance', enabled: true },
                  { id: 4053, title: 'Choking intervention', name: 'chokingIntervention', enabled: true },
                  { id: 4028, title: 'Epileptic seizure', name: 'epilepticSeizure', enabled: true },
                ]
              },
              {
                title: 'Wandering',
                name: 'wandering',
                enabled: true,
                actions: [
                  { id: 9003, title: 'Disturbed', name: 'disturbed', category: 'Sleeping', enabled: true },
                  { id: 9007, title: 'Stay in bed', name: 'stayInBed', category: 'Sleeping', enabled: true },
                  { id: 9090, title: 'Monitoring', name: 'monitoring', category: 'Sleeping', enabled: true },
                ]
              },
              { id: 7032, title: 'Fluid note', name: 'fluidNote', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7034, title: 'Ice cream', name: 'iceCream', category: 'Nutrition eating and drinking', enabled: true },
              { id: 5001, title: 'Agitated', name: 'agitated', enabled: true },
              { id: 5002, title: 'Confused', name: 'confused', enabled: true },
              { id: 5004, title: 'Pacing', name: 'pacing', enabled: true },
              { id: 5005, title: 'Upset', name: 'upset', enabled: true },
              { id: 5007, title: 'Repetitive', name: 'repetitive', enabled: true },
              { id: 5009, title: 'Hallucinated', name: 'hallucinate', enabled: true },
              { id: 5010, title: 'Disinhibited', name: 'disinhibited', enabled: true },
              { id: 10003, title: 'Handover', name: 'handover', category: 'Processes', enabled: true },
              { id: 10005, title: 'Resumed', name: 'resumed', category: 'Processes', enabled: true },
              { id: 10006, title: 'Record height', name: 'recordHeight', category: 'Processes', enabled: true },
              { id: 10009, title: 'Complaint', name: 'complaint', category: 'Processes', enabled: true },
              { id: 10021, title: 'Compliment', name: 'compliment', category: 'Processes', enabled: true },
            ],
          },
          {
            title: 'Recurring Actions',
            name: 'recurringActions',
            enabled: true,
            actions: [
              {
                title: 'Personal Care',
                name: 'personalCare',
                enabled: true,
                actions: [
                  { id: 8014, title: 'Glasses', name: 'checkGlasses', category: 'Personal care', enabled: true },
                  { id: 8002, title: 'Dressed', name: 'dressed', category: 'Personal care', enabled: true },
                  { id: 8024, title: 'Denture care', name: 'dentureCare', category: 'Personal care', enabled: true },
                  { id: 8022, title: 'Menstruation', name: 'menstruation', category: 'Personal care', enabled: true },
                  { id: 8025, title: 'Check ears', name: 'checkEars', category: 'Personal care', enabled: true },
                  { id: 8021, title: 'Change clothes', name: 'changeClothes', category: 'Personal care', enabled: true },
                  { id: 8016, title: 'Make Up', name: 'makeUp', category: 'Personal care', enabled: true },
                  { id: 8015, title: 'Hearing aid', name: 'hearingAid', category: 'Personal care', enabled: true },
                  { id: 8020, title: 'Check eye', name: 'checkEye', category: 'Personal care', enabled: true },
                  { id: 8012, title: 'Check finger nails', name: 'checkFingerNails', category: 'Personal care', enabled: true },
                  { id: 8010, title: 'Hair wash', name: 'hairWash', category: 'Personal care', enabled: true },
                  { id: 8003, title: 'Chiropodist', name: 'chiropodist', category: 'Personal care', enabled: true },
                  { id: 8006, title: 'Shower', name: 'shower', category: 'Personal care', enabled: true },
                  { id: 8013, title: 'Check toe nails', name: 'checkToeNails', category: 'Personal care', enabled: true },
                  { id: 8099, title: 'Personal Care Other', name: 'personalCareOther', category: 'Personal care', enabled: true },
                  { id: 8008, title: 'Oral hygiene', name: 'oralHygiene', category: 'Personal care', enabled: true },
                  { id: 8019, title: 'Catheter care', name: 'catheterCare', category: 'Personal care', enabled: true },
                  { id: 8017, title: 'Laundry', name: 'laundry', category: 'Personal care', enabled: true },
                  { id: 8011, title: 'Hair brushed', name: 'hairBrushed', category: 'Personal care', enabled: true },
                  { id: 8005, title: 'Bath', name: 'bath', category: 'Personal care', enabled: true },
                  { id: 8007, title: 'Cleaning', name: 'cleaning', category: 'Personal care', enabled: true },
                  { id: 8001, title: 'Wash', name: 'wash', category: 'Personal care', enabled: true },
                  { id: 8009, title: 'Shave', name: 'shave', category: 'Personal care', enabled: true },
                  { id: 8018, title: 'Bath temperature', name: 'bathTemperature', category: 'Personal care', enabled: true },
                  { id: 8004, title: 'Hairdresser', name: 'hairdresser', category: 'Personal care', enabled: true },
                  { id: 8023, title: 'Wash hands', name: 'washHands', category: 'Personal care', enabled: true }
                ],
              },
              {
                title: 'Personal Safety and Environment',
                name: 'personalSafetyAndEnvironment',
                enabled: true,
                actions: [
                  { id: 11003, title: 'Change bed', name: 'changeBed', category: 'Personal safety and environment', enabled: true },
                  { id: 11004, title: 'Check mattress', name: 'checkMattress', category: 'Personal safety and environment', enabled: true },
                  { id: 11015, title: 'Check footwear', name: 'checkFootwear', category: 'Personal safety and environment', enabled: true },
                  { id: 11016, title: 'Check equipment', name: 'checkEquipment', category: 'Personal safety and environment', enabled: true },
                  { id: 11009, title: 'Room temperature', name: 'roomTemperature', category: 'Personal safety and environment', enabled: true },
                  { id: 11005, title: 'Check chair', name: 'checkChair', category: 'Personal safety and environment', enabled: true },
                  { id: 11001, title: 'Pendant alarm', name: 'pendantAlarm', category: 'Personal safety and environment', enabled: true },
                  { id: 11010, title: 'Action mat', name: 'actionMat', category: 'Personal safety and environment', enabled: true },
                  { id: 11014, title: 'Check sling', name: 'checkSling', category: 'Personal safety and environment', enabled: true },
                  { id: 11002, title: 'Check OK', name: 'checkOK', category: 'Personal safety and environment', enabled: true },
                  { id: 11013, title: 'Fridge Temperature', name: 'fridgeTemperature', category: 'Personal safety and environment', enabled: true },
                  { id: 11011, title: 'Check Wheelchair', name: 'checkWheelchair', category: 'Personal safety and environment', enabled: true },
                  { id: 11007, title: 'Adjust curtains', name: 'adjustCurtains', category: 'Personal safety and environment', enabled: true },
                  { id: 11008, title: 'Check room', name: 'checkRoom', category: 'Personal safety and environment', enabled: true },
                  { id: 11006, title: 'Check bedrails', name: 'checkBedrails', category: 'Personal safety and environment', enabled: true },
                  { id: 11012, title: 'Wheelchair belt', name: 'wheelchairBelt', category: 'Personal safety and environment', enabled: true }
                ],
              },
              {
                title: 'Nutrition, Eating, and Drinking',
                name: 'nutritionEatingAndDrinking',
                enabled: true,
                actions: [
                  { id: 7001, title: 'Breakfast', name: 'breakfast', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7003, title: 'Tea (meal)', name: 'teaMeal', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7002, title: 'Lunch', name: 'lunch', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7024, title: 'Hot chocolate', name: 'hotChocolate', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7022, title: 'Milkshake', name: 'milkshake', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7028, title: 'Had Jelly Drops', name: 'jellyDrops', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7017, title: 'Out to eat', name: 'eatOut', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7018, title: 'Cafe', name: 'cafe', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7008, title: 'Coffee', name: 'coffee', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7007, title: 'Wine', name: 'wine', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7013, title: 'Take food order to kitchen', name: 'foodOrder', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7029, title: 'Ice lolly', name: 'iceLolly', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7011, title: 'Nutrition watch', name: 'nutritionWatch', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7005, title: 'Tea (drink)', name: 'teaDrink', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7014, title: 'Ensure', name: 'ensure', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7025, title: 'Had soup', name: 'soup', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7030, title: 'Pudding', name: 'pudding', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7023, title: 'Milk', name: 'milk', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7004, title: 'Snack', name: 'snack', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7019, title: 'Alcoholic drink', name: 'alcoholicDrink', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7010, title: 'Fluid watch', name: 'fluidWatch', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7026, title: 'Fluid watch 2', name: 'fluidWatch2', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7031, title: 'Jelly', name: 'jelly', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7021, title: 'Thickened drink', name: 'thickDrink', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7006, title: 'Water', name: 'water', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7009, title: 'Drink', name: 'drink', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7020, title: 'Supper', name: 'supper', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7099, title: 'Nutrition Eating & Drinking-Other', name: 'nutritionEatingDrinkingOther', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7027, title: 'Fluid cap', name: 'fluidCap', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7015, title: 'Fruit juice', name: 'juice', category: 'Nutrition eating and drinking', enabled: true },
                  { id: 7012, title: 'Weigh', name: 'weigh', category: 'Nutrition eating and drinking', enabled: true },
                ],
              },
              {
                title: 'Activities',
                name: 'activities',
                enabled: true,
                actions: [
                  { id: 2003, title: 'Armchair exercises', name: 'armchairExercises', enabled: true },
                  { id: 2035, title: 'Magical', name: 'magical', enabled: true },
                  { id: 2037, title: 'Horse riding', name: 'horseRiding', enabled: true },
                  { id: 2020, title: "Knitting", name: 'knitting', enabled: true },
                  { id: 2030, title: 'Theatre', name: 'theatre', enabled: true },
                  { id: 2029, title: 'Cinema', name: 'cinema', enabled: true },
                  { id: 2034, title: 'Bingo', name: 'bingo', enabled: true },
                  { id: 2009, title: 'Visit relatives', name: 'visitRelatives', enabled: true },
                  { id: 2093, title: 'Oomph! Exercise', name: 'oomphExercise', enabled: true },
                  { id: 2057, title: 'Vape', name: 'vape', enabled: true },
                  { id: 2040, title: 'Massage', name: 'massage', enabled: true },
                  { id: 2043, title: 'Ball games', name: 'ballGames', enabled: true },
                  { id: 2021, title: 'Fete', name: 'fete', enabled: true },
                  { id: 2054, title: 'Sensory', name: 'sensory', enabled: true },
                  { id: 2023, title: 'Shopping', name: 'shopping', enabled: true },
                  { id: 2038, title: 'Cooking', name: 'cooking', enabled: true },
                  { id: 2026, title: 'Birthday', name: 'birthday', enabled: true },
                  { id: 2032, title: 'Pets', name: 'pets', enabled: true },
                  { id: 2004, title: 'Indoor skittles', name: 'indoorSkittles', enabled: true },
                  { id: 2012, title: 'TV', name: 'TV', enabled: true },
                  { id: 2008, title: 'Walk outside', name: 'walkOutside', enabled: true },
                  { id: 2022, title: 'BBQ', name: 'bbq', enabled: true },
                  { id: 2091, title: 'Oomph! Explorer', name: 'oomphExplorer', enabled: true },
                  { id: 2014, title: 'Film', name: 'film', enabled: true },
                  { id: 2047, title: 'PEC Schedule', name: 'PECSchedule', enabled: true },
                  { id: 2019, title: 'Reading', name: 'reading', enabled: true },
                  { id: 2013, title: 'Music', name: 'music', enabled: true },
                  { id: 2099, title: 'Activities-Other', name: 'activitiesOther', enabled: true },
                  { id: 2046, title: 'Housework', name: 'housework', enabled: true },
                  { id: 2039, title: 'Games console', name: 'gamesConsole', enabled: true },
                  { id: 2056, title: 'Digital Table', name: 'digitalTable', enabled: true },
                  { id: 2049, title: 'Driving', name: 'driving', enabled: true },
                  { id: 2092, title: 'Oomph! Digest', name: 'oomphDigest', enabled: true },
                  { id: 2015, title: 'Played Game', name: 'playedGame', enabled: true },
                  { id: 2024, title: 'Outing', name: 'outing', enabled: true },
                  { id: 2095, title: 'Oomph! OnDemand', name: 'oomphOnDemand', enabled: true },
                  { id: 2089, title: 'ReMe', name: 'reMe', enabled: true },
                  { id: 2018, title: 'Sitting room', name: 'sittingRoom', enabled: true },
                  { id: 2050, title: 'Singing', name: 'singing', enabled: true },
                  { id: 2005, title: 'Entertainer', name: 'entertainer', enabled: true },
                  { id: 2090, title: 'Oomph! Calendar', name: 'oomphCalendar', enabled: true },
                  { id: 2041, title: 'Exercise', name: 'exercise', enabled: true },
                  { id: 2033, title: 'Visitor', name: 'visitor', enabled: true },
                  { id: 2094, title: 'Oomph! Wireless', name: 'oomphWireless', enabled: true },
                  { id: 2016, title: 'Quiz', name: 'quiz', enabled: true },
                  { id: 2010, title: 'Pub', name: 'pub', enabled: true },
                  { id: 2025, title: 'Day Centre', name: 'dayCentre', enabled: true },
                  { id: 2028, title: 'Computer', name: 'computer', enabled: true },
                  { id: 2031, title: 'Gardening', name: 'gardening', enabled: true },
                  { id: 2006, title: 'Concert', name: 'concert', enabled: true },
                  { id: 2055, title: 'Daily Sparkle', name: 'dailySparkle', enabled: true },
                  { id: 2045, title: 'Youth Club', name: 'Youth Club', enabled: true },
                  { id: 2051, title: 'Dominoes', name: 'dominoes', enabled: true },
                  { id: 2017, title: 'Arts/Crafts', name: 'artsCrafts', enabled: true },
                  { id: 2088, title: 'Interactive Me', name: 'interactiveMe', enabled: true },
                  { id: 2053, title: 'Community', name: 'community', enabled: true },
                  { id: 2036, title: 'Swimming', name: 'swimming', enabled: true },
                  { id: 2044, title: 'Relaxation', name: 'relaxation', enabled: true },
                  { id: 2007, title: 'Crossword', name: 'crossword', enabled: true },
                  { id: 2042, title: 'Bowling', name: 'bowling', enabled: true },
                  { id: 2048, title: 'Cigarette', name: 'cigarette', enabled: true },
                  { id: 2027, title: 'Party', name: 'party', enabled: true },
                  { id: 2011, title: 'Church', name: 'church', enabled: true }
                ]
              },
              {
                title: 'Communication',
                name: 'communication',
                enabled: true,
                actions: [
                  { id: 8, title: 'Help reading', name: 'helpReading', enabled: true },
                  { id: 6, title: 'Help writing', name: 'helpWriting', enabled: true },
                  { id: 7, title: 'Speaking', name: 'speaking', enabled: true },
                  { id: 2, title: 'Chatted', name: 'chatted', enabled: true },
                  { id: 5, title: 'Read letter', name: 'readLetter', enabled: true },
                  { id: 1, title: 'Newspaper', name: 'newspaper', enabled: true },
                  { id: 4, title: 'Write letter', name: 'writeLetter', enabled: true },
                  { id: 3, title: 'Email', name: 'email', enabled: true },
                  { id: 10, title: 'Phone', name: 'phone', enabled: true },
                  { id: 11, title: 'Mentoring', name: 'mentoring', enabled: true },
                  { id: 9, title: 'Can’t communicate', name: 'cantCommunicate', enabled: true },
                  { id: 99, title: 'Communication-Other', name: 'communicationOther', enabled: true },
                  { id: 9004, title: 'Bell', name: 'bell', enabled: true },
                ]
              },
              {
                title: 'Toileting',
                name: 'toileting',
                enabled: true,
                actions: [
                  { id: 1003, title: 'Toilet help', name: 'toiletHelp', enabled: true },
                  { id: 1007, title: 'Bed pan', name: 'bedPan', enabled: true },
                  { id: 1010, title: 'Urine bottle', name: 'urineBottle', enabled: true },
                  { id: 1008, title: 'Commode', name: 'commode', enabled: true },
                  { id: 9002, title: 'Pad check', name: 'padCheck', enabled: true },
                  { id: 1009, title: 'Urinate', name: 'urinate', enabled: true },
                  { id: 1001, title: 'Bowels opened', name: 'bowelsOpened', enabled: true },
                  { id: 4017, title: 'Emptied', name: 'emptied', enabled: true },
                  { id: 1006, title: 'Help with toilet', name: 'helpWithToilet', enabled: true },
                  { id: 1099, title: 'Toileting-Other', name: 'toiletingOther', enabled: true }
                ],
              },
              {
                title: 'Mobility',
                name: 'mobility',
                enabled: true,
                actions: [
                  { id: 6008, title: 'Onto chair', name: 'ontoChair', category: 'Mobility', enabled: true },
                  { id: 6004, title: 'Up from Chair', name: 'upFromChair', category: 'Mobility', enabled: true },
                  { id: 6007, title: 'Into bed', name: 'intoBed', category: 'Mobility', enabled: true },
                  { id: 6005, title: 'Out of Bed', name: 'outOfBed', category: 'Mobility', enabled: true },
                  { id: 6006, title: 'Hoist 2 People', name: 'hoist2People', category: 'Mobility', enabled: true },
                  { id: 6010, title: 'Standing hoist', name: 'standingHoist', category: 'Mobility', enabled: true },
                  { id: 6011, title: 'Handling belt', name: 'handlingBelt', category: 'Mobility', enabled: true },
                  { id: 6012, title: 'Elevate legs', name: 'elevateLegs', category: 'Mobility', enabled: true },
                  { id: 6009, title: 'Moved', name: 'moved', category: 'Mobility', enabled: true },
                  { id: 6001, title: 'Walk', name: 'walk', category: 'Mobility', enabled: true },
                  { id: 6002, title: 'Stairs', name: 'stairs', category: 'Mobility', enabled: true },
                  { id: 9008, title: 'Reposition', name: 'reposition', category: 'Mobility', enabled: true },
                  { id: 6099, title: 'Mobility-Other', name: 'mobilityOther', category: 'Mobility', enabled: true }
                ],
              },
              {
                title: 'Medical',
                name: 'medical',
                enabled: true,
                actions: [
                  { id: 4001, title: 'Medication', name: 'medication', enabled: true },
                  { id: 4002, title: 'PRN Medication', name: 'prnMedication', enabled: true },
                  { id: 4005, title: 'Doctor', name: 'doctor', enabled: true },
                  { id: 4006, title: 'Nurse', name: 'nurse', enabled: true },
                  { id: 4007, title: 'Qualified Specialist', name: 'specialist', enabled: true },
                  { id: 4041, title: 'Professional', name: 'professional', enabled: true },
                  { id: 2040, title: 'Massage', name: 'massage', enabled: true },
                  { id: 4009, title: 'Dress wound', name: 'wound', enabled: true },
                  { id: 4044, title: 'Heat pack', name: 'heatPack', enabled: true },
                  { id: 4019, title: 'Cream', name: 'cream', enabled: true },
                  { id: 4039, title: 'Foot splint', name: 'footSplint', enabled: true },
                  { id: 4040, title: 'Hand splint', name: 'handSplint', enabled: true },
                  { id: 4038, title: 'Compression garment', name: 'compression', enabled: true },
                  { id: 4020, title: 'Skin', name: 'skinIntegrity', enabled: true },
                  { id: 4047, title: 'Neuro Obs.', name: 'neuroObs', enabled: true },
                  { id: 4022, title: 'Pulse', name: 'pulse', enabled: true },
                  { id: 4042, title: 'Blood test', name: 'bloodTest', enabled: true },
                  { id: 7016, title: 'Blood sugar', name: 'bloodSugar', enabled: true },
                  { id: 4050, title: 'Soft signs', name: 'softSigns', enabled: true },
                  { id: 4027, title: 'Insulin', name: 'insulin', enabled: true },
                  { id: 4024, title: 'Temperature', name: 'temperature', enabled: true },
                  { id: 4021, title: 'Blood pressure', name: 'bloodPressure', enabled: true },
                  { id: 4025, title: 'Blood O2', name: 'bloodO2', enabled: true },
                  { id: 4037, title: 'Blood INR', name: 'bloodINR', enabled: true },
                  { id: 4023, title: 'Respiration', name: 'respiration', enabled: true },
                  { id: 4049, title: 'Coronavirus', name: 'coronavirus', enabled: true },
                  { id: 4049, title: 'Coronavirus symptom check', name: 'coronavirusSymptomCheck', enabled: true },
                  { id: 4045, title: 'Consciousness', name: 'consciousness', enabled: true },
                  { id: 4052, title: 'NEWS2', name: 'news2', enabled: true },
                  { id: 4046, title: 'PainAssessment', name: 'inPain', enabled: true },
                  { id: 4055, title: 'SD Check', name: 'sdCheck', enabled: true },
                  { id: 4054, title: 'SD Setup / Change', name: 'sdSetupChange', enabled: true },
                  { id: 4010, title: 'New catheter', name: 'newCatheter', enabled: true },
                  { id: 4015, title: 'Bladder washout', name: 'washout', enabled: true },
                  { id: 4016, title: 'Add catheter bag', name: 'addBag', enabled: true },
                  { id: 4018, title: 'Change catheter bag', name: 'cleaned', enabled: true },
                  { id: 4011, title: 'Gastrostomy Feed', name: 'peg', enabled: true },
                  { id: 4012, title: 'Stoma', name: 'stoma', enabled: true },
                  { id: 4030, title: 'Suction', name: 'suction', enabled: true },
                  { id: 4029, title: 'Tracheostomy', name: 'tracheostomy', enabled: true },
                  { id: 4013, title: 'Enema', name: 'enema', enabled: true },
                  { id: 4033, title: 'IV line flush', name: 'ivLineFlush', enabled: true },
                  { id: 4014, title: 'Sample', name: 'sample', enabled: true },
                  { id: 4034, title: 'Multistix', name: 'multistix', enabled: true },
                  { id: 4035, title: 'Ear syringe', name: 'earSyringe', enabled: true },
                  { id: 4032, title: 'Clinic', name: 'clinic', enabled: true },
                  { id: 4031, title: 'Hospital', name: 'hospital', enabled: true },
                  { id: 4048, title: 'Therapeutic massage', name: 'therapeuticMassage', enabled: true },
                  { id: 4043, title: 'PAP therapy', name: 'PAPTherapy', enabled: true },
                  { id: 4051, title: 'Oxygen level', name: 'oxygenLevel', enabled: true },
                  { id: 4099, title: 'Other', name: 'medicalOther', enabled: true }
                ],
              },
              {
                title: 'Emotional Support',
                name: 'emotionalSupport',
                enabled: true,
                actions: [
                  { id: 5003, title: 'Distress reaction', name: 'distressReaction', enabled: true },
                  { id: 5006, title: 'Social worker', name: 'socialWorker', enabled: true },
                  { id: 5008, title: 'Paranoid', name: 'paranoid', enabled: true },
                  { id: 5099, title: 'Emotional support', name: 'emotionalSupport', enabled: true },
                ]
              },
              {
                title: 'Sleeping',
                name: 'sleeping',
                enabled: true,
                actions: [
                  { id: 9001, title: 'Check sleep', name: 'checkSleep', category: 'Sleeping', enabled: true },
                  { id: 9002, title: 'Check pad', name: 'checkPad', category: 'Sleeping', enabled: true },
                  { id: 9099, title: 'Sleeping-Other', name: 'sleepingOther', category: 'Sleeping', enabled: true },
                ]
              },
              {
                title: 'Process',
                name: 'process',
                enabled: true,
                actions: [
                  { id: 10007, title: 'Admitted', name: 'visitStart', category: 'Processes', enabled: true },
                  { id: 10002, title: 'Visit start', name: 'visit', category: 'Processes', enabled: true },
                  { id: 10011, title: 'Visit end', name: 'visit1', category: 'Processes', enabled: true },
                  { id: 10010, title: 'Personal money', name: 'personalMoney', category: 'Processes', enabled: true },
                  { id: 10022, title: 'Transport', name: 'transport', category: 'Processes', enabled: true },
                  { id: 10004, title: 'Suspended', name: 'suspended', category: 'Processes', enabled: true },
                  { id: 10001, title: 'Shift handover', name: 'shiftHandover', category: 'Processes', enabled: true },
                  { id: 111001, title: 'Staff message', name: 'staffMessage', category: 'Processes', enabled: true },
                  { id: 10014, title: 'Alert', name: 'alert', category: 'Processes', enabled: true },
                  { id: 10023, title: 'Keyworker', name: 'keyworker', category: 'Processes', enabled: true },
                  { id: 10008, title: 'Discharged', name: 'visit2', category: 'Processes', enabled: true },
                  { id: 10013, title: 'Manager', name: 'manager', category: 'Processes', enabled: true },
                  { id: 10012, title: 'Relative', name: 'relative', category: 'Processes', enabled: true },
                ],
              }
            ]
          }
        ],
        dailyCare: [
          {
            title: 'Personal Care',
            name: 'personalCare',
            enabled: true,
            actions: [
              { id: 8014, title: 'Glasses', name: 'checkGlasses', category: 'Personal care', enabled: true },
              { id: 8002, title: 'Dressed', name: 'dressed', category: 'Personal care', enabled: true },
              { id: 8024, title: 'Denture care', name: 'dentureCare', category: 'Personal care', enabled: true },
              { id: 8022, title: 'Menstruation', name: 'menstruation', category: 'Personal care', enabled: true },
              { id: 8025, title: 'Check ears', name: 'checkEars', category: 'Personal care', enabled: true },
              { id: 8021, title: 'Change clothes', name: 'changeClothes', category: 'Personal care', enabled: true },
              { id: 8016, title: 'Make Up', name: 'makeUp', category: 'Personal care', enabled: true },
              { id: 8015, title: 'Hearing aid', name: 'hearingAid', category: 'Personal care', enabled: true },
              { id: 8020, title: 'Check eye', name: 'checkEye', category: 'Personal care', enabled: true },
              { id: 8012, title: 'Check finger nails', name: 'checkFingerNails', category: 'Personal care', enabled: true },
              { id: 8010, title: 'Hair wash', name: 'hairWash', category: 'Personal care', enabled: true },
              { id: 8003, title: 'Chiropodist', name: 'chiropodist', category: 'Personal care', enabled: true },
              { id: 8006, title: 'Shower', name: 'shower', category: 'Personal care', enabled: true },
              { id: 8013, title: 'Check toe nails', name: 'checkToeNails', category: 'Personal care', enabled: true },
              { id: 8099, title: 'Personal Care Other', name: 'personalCareOther', category: 'Personal care', enabled: true },
              { id: 8008, title: 'Oral hygiene', name: 'oralHygiene', category: 'Personal care', enabled: true },
              { id: 8008, title: 'Teeth/mouth cleaned', name: 'teethMouthCleaned', category: 'Personal care', enabled: true },
              { id: 8019, title: 'Catheter care', name: 'catheterCare', category: 'Personal care', enabled: true },
              { id: 8017, title: 'Laundry', name: 'laundry', category: 'Personal care', enabled: true },
              { id: 8011, title: 'Hair brushed', name: 'hairBrushed', category: 'Personal care', enabled: true },
              { id: 8005, title: 'Bath', name: 'bath', category: 'Personal care', enabled: true },
              { id: 8007, title: 'Cleaning', name: 'cleaning', category: 'Personal care', enabled: true },
              { id: 8001, title: 'Wash', name: 'wash', category: 'Personal care', enabled: true },
              { id: 8009, title: 'Shave', name: 'shave', category: 'Personal care', enabled: true },
              { id: 8018, title: 'Bath temperature', name: 'bathTemperature', category: 'Personal care', enabled: true },
              { id: 8004, title: 'Hairdresser', name: 'hairdresser', category: 'Personal care', enabled: true },
              { id: 8023, title: 'Wash hands', name: 'washHands', category: 'Personal care', enabled: true }
            ],
          },
          {
            title: 'Personal Safety and Environment',
            name: 'personalSafetyAndEnvironment',
            enabled: true,
            actions: [
              { id: 11003, title: 'Change bed', name: 'changeBed', category: 'Personal safety and environment', enabled: true },
              { id: 11004, title: 'Check mattress', name: 'checkMattress', category: 'Personal safety and environment', enabled: true },
              { id: 11015, title: 'Check footwear', name: 'checkFootwear', category: 'Personal safety and environment', enabled: true },
              { id: 11016, title: 'Check equipment', name: 'checkEquipment', category: 'Personal safety and environment', enabled: true },
              { id: 11009, title: 'Room temperature', name: 'roomTemperature', category: 'Personal safety and environment', enabled: true },
              { id: 11005, title: 'Check chair', name: 'checkChair', category: 'Personal safety and environment', enabled: true },
              { id: 11001, title: 'Pendant alarm', name: 'pendantAlarm', category: 'Personal safety and environment', enabled: true },
              { id: 11010, title: 'Action mat', name: 'actionMat', category: 'Personal safety and environment', enabled: true },
              { id: 11014, title: 'Check sling', name: 'checkSling', category: 'Personal safety and environment', enabled: true },
              { id: 11002, title: 'Check OK', name: 'checkOK', category: 'Personal safety and environment', enabled: true },
              { id: 11013, title: 'Fridge Temperature', name: 'fridgeTemperature', category: 'Personal safety and environment', enabled: true },
              { id: 11011, title: 'Check Wheelchair', name: 'checkWheelchair', category: 'Personal safety and environment', enabled: true },
              { id: 11007, title: 'Adjust curtains', name: 'adjustCurtains', category: 'Personal safety and environment', enabled: true },
              { id: 11008, title: 'Check room', name: 'checkRoom', category: 'Personal safety and environment', enabled: true },
              { id: 11006, title: 'Check bedrails', name: 'checkBedrails', category: 'Personal safety and environment', enabled: true },
              { id: 11012, title: 'Wheelchair belt', name: 'wheelchairBelt', category: 'Personal safety and environment', enabled: true }
            ],
          },
          {
            title: 'Nutrition Eating and Drinking',
            name: 'nutritionEatingAndDrinking',
            enabled: true,
            actions: [
              { id: 7003, title: 'Tea (meal)', name: 'teaMeal', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7002, title: 'Lunch', name: 'lunch', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7024, title: 'Hot chocolate', name: 'hotChocolate', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7022, title: 'Milkshake', name: 'milkshake', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7028, title: 'Had Jelly Drops', name: 'jellyDrops', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7017, title: 'Out to eat', name: 'eatOut', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7018, title: 'Cafe', name: 'cafe', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7008, title: 'Coffee', name: 'coffee', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7007, title: 'Wine', name: 'wine', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7013, title: 'Take food order to kitchen', name: 'foodOrder', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7029, title: 'Ice lolly', name: 'iceLolly', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7011, title: 'Nutrition watch', name: 'nutritionWatch', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7005, title: 'Tea (drink)', name: 'teaDrink', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7014, title: 'Ensure', name: 'ensure', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7034, title: 'Ice Cream', name: 'iceCream', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7025, title: 'Had soup', name: 'soup', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7030, title: 'Pudding', name: 'pudding', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7023, title: 'Milk', name: 'milk', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7032, title: 'Fluid', name: 'fluidNote', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7004, title: 'Snack', name: 'snack', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7019, title: 'Alcoholic drink', name: 'alcoholicDrink', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7010, title: 'Fluid watch', name: 'fluidWatch', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7026, title: 'Fluid watch 2', name: 'fluidWatch2', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7031, title: 'Jelly', name: 'jelly', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7021, title: 'Thickened drink', name: 'thickDrink', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7006, title: 'Water', name: 'water', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7009, title: 'Drink', name: 'drink', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7020, title: 'Supper', name: 'supper', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7099, title: 'Other', name: 'nutritionEatingDrinkingOther', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7027, title: 'Fluid cap', name: 'fluidCap', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7033, title: 'Soft Drink', name: 'softDrink', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7015, title: 'Fruit juice', name: 'juice', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7012, title: 'Weigh', name: 'weigh', category: 'Nutrition eating and drinking', enabled: true },
              { id: 7001, title: 'Breakfast', name: 'breakfast', category: 'Nutrition eating and drinking', enabled: true }
            ],
          },
          {
            title: 'Activities',
            name: 'activities',
            enabled: true,
            actions: [
              { id: 2003, title: 'Armchair exercises', name: 'armchairExercises', enabled: true },
              { id: 2035, title: 'Magical', name: 'magical', enabled: true },
              { id: 2037, title: 'Horse riding', name: 'horseRiding', enabled: true },
              { id: 2020, title: "Knitting", name: 'knitting', enabled: true },
              { id: 2030, title: 'Theatre', name: 'theatre', enabled: true },
              { id: 2029, title: 'Cinema', name: 'cinema', enabled: true },
              { id: 2034, title: 'Bingo', name: 'bingo', enabled: true },
              { id: 2009, title: 'Visit relatives', name: 'visitRelatives', enabled: true },
              { id: 2093, title: 'Oomph! Exercise', name: 'oomphExercise', enabled: true },
              { id: 2057, title: 'Vape', name: 'vape', enabled: true },
              { id: 2040, title: 'Massage', name: 'massage', enabled: true },
              { id: 2043, title: 'Ball games', name: 'ballGames', enabled: true },
              { id: 2021, title: 'Fete', name: 'fete', enabled: true },
              { id: 2054, title: 'Sensory', name: 'sensory', enabled: true },
              { id: 2023, title: 'Shopping', name: 'shopping', enabled: true },
              { id: 2038, title: 'Cooking', name: 'cooking', enabled: true },
              { id: 2026, title: 'Birthday', name: 'birthday', enabled: true },
              { id: 2032, title: 'Pets', name: 'pets', enabled: true },
              { id: 2004, title: 'Indoor skittles', name: 'indoorSkittles', enabled: true },
              { id: 2012, title: 'TV', name: 'TV', enabled: true },
              { id: 2008, title: 'Walk outside', name: 'walkOutside', enabled: true },
              { id: 2022, title: 'BBQ', name: 'bbq', enabled: true },
              { id: 2091, title: 'Oomph! Explorer', name: 'oomphExplorer', enabled: true },
              { id: 2014, title: 'Film', name: 'film', enabled: true },
              { id: 2047, title: 'PEC Schedule', name: 'pecSchedule', enabled: true },
              { id: 2019, title: 'Reading', name: 'reading', enabled: true },
              { id: 2013, title: 'Music', name: 'music', enabled: true },
              { id: 2099, title: 'Activities-Other', name: 'activitiesOther', enabled: true },
              { id: 2046, title: 'Housework', name: 'housework', enabled: true },
              { id: 2039, title: 'Games console', name: 'gamesConsole', enabled: true },
              { id: 2056, title: 'Digital Table', name: 'digitalTable', enabled: true },
              { id: 2049, title: 'Driving', name: 'driving', enabled: true },
              { id: 2092, title: 'Oomph! Digest', name: 'oomphDigest', enabled: true },
              { id: 2015, title: 'Played Game', name: 'playedGame', enabled: true },
              { id: 2024, title: 'Outing', name: 'outing', enabled: true },
              { id: 2095, title: 'Oomph! OnDemand', name: 'oomphOnDemand', enabled: true },
              { id: 2089, title: 'ReMe', name: 'reMe', enabled: true },
              { id: 2018, title: 'Sitting room', name: 'sittingRoom', enabled: true },
              { id: 2050, title: 'Singing', name: 'singing', enabled: true },
              { id: 2005, title: 'Entertainer', name: 'entertainer', enabled: true },
              { id: 2090, title: 'Oomph! Calendar', name: 'oomphCalendar', enabled: true },
              { id: 2041, title: 'Exercise', name: 'exercise', enabled: true },
              { id: 2033, title: 'Visitor', name: 'visitor', enabled: true },
              { id: 2094, title: 'Oomph! Wireless', name: 'oomphWireless', enabled: true },
              { id: 2016, title: 'Quiz', name: 'quiz', enabled: true },
              { id: 2010, title: 'Pub', name: 'pub', enabled: true },
              { id: 2025, title: 'Day Centre', name: 'dayCentre', enabled: true },
              { id: 2028, title: 'Computer', name: 'computer', enabled: true },
              { id: 2031, title: 'Gardening', name: 'gardening', enabled: true },
              { id: 2006, title: 'Concert', name: 'сoncert', enabled: true },
              { id: 2055, title: 'Daily Sparkle', name: 'dailySparkle', enabled: true },
              { id: 2045, title: 'Youth Club', name: 'Youth Club', enabled: true },
              { id: 2051, title: 'Dominoes', name: 'dominoes', enabled: true },
              { id: 2017, title: 'Arts/Crafts', name: 'artsCrafts', enabled: true },
              { id: 2088, title: 'Reminisce', name: 'reminisce', enabled: true },
              { id: 2053, title: 'Community', name: 'community', enabled: true },
              { id: 2036, title: 'Swimming', name: 'swimming', enabled: true },
              { id: 2044, title: 'Relaxation', name: 'relaxation', enabled: true },
              { id: 2007, title: 'Crossword', name: 'crossword', enabled: true },
              { id: 2042, title: 'Bowling', name: 'bowling', enabled: true },
              { id: 2048, title: 'Cigarette', name: 'cigarette', enabled: true },
              { id: 2027, title: 'Party', name: 'party', enabled: true },
              { id: 2011, title: 'Church', name: 'church', enabled: true },
              { id: 2001, title: 'Stayed in room', name: 'stayedInRoom', enabled: true },
              { id: 2002, title: 'Returned to room', name: 'returnedToRoom', enabled: true },
              { id: 2088, title: 'Interactive Me', name: 'interactiveMe', enabled: true },
            ]
          },
          {
            title: 'Communication',
            name: 'communication',
            enabled: true,
            actions: [
              { id: 8, title: 'Help reading', name: 'helpReading', enabled: true },
              { id: 6, title: 'Help writing', name: 'helpWriting', enabled: true },
              { id: 7, title: 'Speaking', name: 'speaking', enabled: true },
              { id: 2, title: 'Chatted', name: 'chatted', enabled: true },
              { id: 5, title: 'Read letter', name: 'readLetter', enabled: true },
              { id: 1, title: 'Newspaper', name: 'newspaper', enabled: true },
              { id: 4, title: 'Write letter', name: 'writeLetter', enabled: true },
              { id: 3, title: 'Email', name: 'email', enabled: true },
              { id: 10, title: 'Phone', name: 'phone', enabled: true },
              { id: 11, title: 'Mentoring', name: 'mentoring', enabled: true },
              { id: 9, title: 'Can’t communicate', name: 'cantCommunicate', enabled: true },
              { id: 9004, title: 'Bell', name: 'bell', enabled: true },
              { id: 99, title: 'Communication-Other', name: 'communicationOther', enabled: true }
            ]
          },
          {
            title: 'Toileting',
            name: 'toileting',
            enabled: true,
            actions: [
              { id: 1003, title: 'Toilet help', name: 'toiletHelp', enabled: true },
              { id: 1007, title: 'Bed pan', name: 'bedPan', enabled: true },
              { id: 1010, title: 'Urine bottle', name: 'urineBottle', enabled: true },
              { id: 1008, title: 'Commode', name: 'commode', enabled: true },
              { id: 9002, title: 'Pad check', name: 'padCheck', enabled: true },
              { id: 1009, title: 'Urinate', name: 'urinate', enabled: true },
              { id: 1001, title: 'Bowels opened', name: 'bowelsOpened', enabled: true },
              { id: 4017, title: 'Emptied', name: 'emptied', enabled: true },
              { id: 1004, title: 'Wet clothes', name: 'wetClothes', enabled: true },
              { id: 1006, title: 'Help with toilet', name: 'helpWithToilet', enabled: true },
              { id: 1005, title: 'Soiled clothes', name: 'soiledClothes', enabled: true },
              { id: 1099, title: 'Toileting-Other', name: 'toiletingOther', enabled: true },
              { id: 1002, title: 'Loose bowels', name: 'looseBowels', enabled: true },
            ],
          },
          {
            title: 'Mobility',
            name: 'mobility',
            enabled: true,
            actions: [
              { id: 6008, title: 'Onto chair', name: 'ontoChair', category: 'Mobility', enabled: true },
              { id: 6004, title: 'Up from Chair', name: 'upFromChair', category: 'Mobility', enabled: true },
              { id: 6007, title: 'Into bed', name: 'intoBed', category: 'Mobility', enabled: true },
              { id: 6005, title: 'Out of Bed', name: 'outOfBed', category: 'Mobility', enabled: true },
              { id: 6006, title: 'Hoist 2 People', name: 'hoist2People', category: 'Mobility', enabled: true },
              { id: 6010, title: 'Standing hoist', name: 'standingHoist', category: 'Mobility', enabled: true },
              { id: 6011, title: 'Handling belt', name: 'handlingBelt', category: 'Mobility', enabled: true },
              { id: 6012, title: 'Elevate legs', name: 'elevateLegs', category: 'Mobility', enabled: true },
              { id: 6009, title: 'Moved', name: 'moved', category: 'Mobility', enabled: true },
              { id: 6001, title: 'Walk', name: 'walk', category: 'Mobility', enabled: true },
              { id: 6002, title: 'Stairs', name: 'stairs', category: 'Mobility', enabled: true },
              { id: 9008, title: 'Reposition', name: 'reposition', category: 'Mobility', enabled: true },
              { id: 6003, title: 'Fall', name: 'fall', category: 'Mobility', enabled: true },
              { id: 6099, title: 'Mobility-Other', name: 'mobilityOther', category: 'Mobility', enabled: true }
            ],
          },
          {
            title: 'Medical',
            name: 'medical',
            enabled: true,
            actions: [
              { id: 4001, title: 'Medication', name: 'medication', enabled: true },
              { id: 4042, title: 'Blood test', name: 'bloodTest', enabled: true },
              { id: 2040, title: 'Massage', name: 'massage', enabled: true },
              { id: 4051, title: 'Oxygen level', name: 'oxygenLevel', enabled: true },
              { id: 4099, title: 'Medical-Other', name: 'medicalOther', enabled: true },
              { id: 4002, title: 'PRN Medication', name: 'PRNMedication', enabled: true },
              { id: 4009, title: 'Wound', name: 'wound', enabled: true },
              { id: 4050, title: 'Soft signs', name: 'softSigns', enabled: true },
              { id: 4020, title: 'Skin integrity', name: 'skinIntegrity', enabled: true },
              { id: 4021, title: 'Blood pressure', name: 'bloodPressure', enabled: true },
              { id: 4035, title: 'Ear syringe', name: 'earSyringe', enabled: true },
              { id: 4041, title: 'Professional', name: 'professional', enabled: true },
              { id: 4044, title: 'Heat pack', name: 'heatPack', enabled: true },
              { id: 4018, title: 'Cleaned', name: 'cleaned', enabled: true },
              { id: 4023, title: 'Respiration', name: 'respiration', enabled: true },
              { id: 4025, title: 'Blood O2', name: 'bloodO2', enabled: true },
              { id: 4014, title: 'Sample', name: 'sample', enabled: true },
              { id: 4040, title: 'Hand splint', name: 'handSplint', enabled: true },
              { id: 4006, title: 'Nurse', name: 'nurse', enabled: true },
              { id: 4029, title: 'Tracheostomy', name: 'tracheostomy', enabled: true },
              { id: 4022, title: 'Pulse', name: 'pulse', enabled: true },
              { id: 4039, title: 'Foot splint', name: 'footSplint', enabled: true },
              { id: 4047, title: 'Neuro Obs', name: 'neuroObs', enabled: true },
              { id: 4016, title: 'Add bag', name: 'addBag', enabled: true },
              { id: 4011, title: 'Gastrostomy Feed', name: 'PEG', enabled: true },
              { id: 4036, title: 'In pain', name: 'inPain', enabled: true },
              { id: 4024, title: 'Temperature', name: 'temperature', enabled: true },
              { id: 7016, title: 'Blood sugar', name: 'bloodSugar', enabled: true },
              { id: 4033, title: 'IV line flush', name: 'IVLineFlush', enabled: true },
              { id: 4012, title: 'Stoma', name: 'stoma', enabled: true },
              { id: 4053, title: 'Choking Intervention', name: 'chokingIntervention', enabled: true },
              { id: 4038, title: 'Compression', name: 'compression', enabled: true },
              { id: 4032, title: 'Clinic', name: 'clinic', enabled: true },
              { id: 4034, title: 'Multistix', name: 'multistix', enabled: true },
              { id: 4013, title: 'Enema', name: 'enema', enabled: true },
              { id: 4055, title: 'SD Check', name: 'SDCheck', enabled: true },
              { id: 4004, title: 'Ambulance', name: 'ambulance', enabled: true },
              { id: 4005, title: 'Doctor', name: 'doctor', enabled: true },
              { id: 4030, title: 'Suction', name: 'suction', enabled: true },
              { id: 4019, title: 'Cream', name: 'cream', enabled: true },
              { id: 4008, title: 'Sick', name: 'sick', enabled: true },
              { id: 4015, title: 'Washout', name: 'washout', enabled: true },
              { id: 4045, title: 'Consciousness', name: 'consciousness', enabled: true },
              { id: 4054, title: 'SD Setup / Change', name: 'SDSetupChange', enabled: true },
              { id: 4010, title: 'New catheter', name: 'newCatheter', enabled: true },
              { id: 4028, title: 'Epileptic seizure', name: 'epilepticSeizure', enabled: true },
              { id: 4007, title: 'Qualified Specialist', name: 'specialist', enabled: true },
              { id: 4031, title: 'Hospital', name: 'hospital', enabled: true },
              { id: 4027, title: 'Insulin', name: 'insulin', enabled: true },
              { id: 4048, title: 'Therapeutic massage', name: 'therapeuticMassage', enabled: true },
              { id: 4049, title: 'Coronavirus', name: 'coronavirus', enabled: true },
              { id: 4046, title: 'Pain Assessment', name: 'Pain Assessment', enabled: true },
              { id: 4043, title: 'PAP therapy', name: 'papTherapy', enabled: true },
              { id: 4037, title: 'Blood INR', name: 'bloodINR', enabled: true },
              { id: 4052, title: 'NEWS2', name: 'NEWS2', enabled: true },
              { id: 4003, title: 'Call doctor', name: 'callDoctor', enabled: true }
            ]
          },
          {
            title: 'Emotional Support',
            name: 'emotionalSupport',
            enabled: true,
            actions: [
              { id: 5011, title: 'Wandering', name: 'wandering', enabled: true },
              { id: 5004, title: 'Pacing', name: 'pacing', enabled: true },
              { id: 5006, title: 'Social worker', name: 'socialWorker', enabled: true },
              { id: 5008, title: 'Paranoid', name: 'paranoid', enabled: true },
              { id: 5003, title: 'Distress reaction', name: 'distressReaction', enabled: true },
              { id: 5010, title: 'Disinhibited', name: 'disinhibited', enabled: true },
              { id: 5007, title: 'Repetitive', name: 'repetitive', enabled: true },
              { id: 5009, title: 'Hallucinate', name: 'hallucinate', enabled: true },
              { id: 5005, title: 'Upset', name: 'upset', enabled: true },
              { id: 5099, title: 'Emotional support', name: 'emotionalSupport', enabled: true },
              { id: 5001, title: 'Agitated', name: 'agitated', enabled: true },
              { id: 5002, title: 'Confused', name: 'confused', enabled: true }
            ],
          },
          {
            title: 'Sleeping',
            name: 'sleeping',
            enabled: true,
            actions: [
              { id: 9090, title: 'Monitoring', name: 'monitoring', category: 'Sleeping', enabled: true },
              { id: 9007, title: 'Stay in bed', name: 'stayInBed', category: 'Sleeping', enabled: true },
              { id: 9099, title: 'Sleeping-Other', name: 'sleepingOther', category: 'Sleeping', enabled: true },
              { id: 9003, title: 'Disturbed', name: 'disturbed', category: 'Sleeping', enabled: true },
              { id: 9002, title: 'Check pad', name: 'checkPad', category: 'Sleeping', enabled: true },
              { id: 9001, title: 'Check sleep', name: 'checkSleep', category: 'Sleeping', enabled: true }
            ],
          },
          {
            title: 'Non-ADL',
            name: 'nonADL',
            enabled: true,
            actions: [
              { id: 10003, title: 'Handover', name: 'handover', category: 'Processes', enabled: true },
              { id: 10001, title: 'Visit', name: 'visit', category: 'Processes', enabled: true },
              { id: 10013, title: 'Manager', name: 'manager', category: 'Processes', enabled: true },
              { id: 10010, title: 'Personal money', name: 'personalMoney', category: 'Processes', enabled: true },
              { id: 10005, title: 'Resumed', name: 'resumed', category: 'Processes', enabled: true },
              { id: 10006, title: 'Record height', name: 'recordHeight', category: 'Processes', enabled: true },
              { id: 10009, title: 'Complaint', name: 'complaint', category: 'Processes', enabled: true },
              { id: 10012, title: 'Relative', name: 'relative', category: 'Processes', enabled: true },
              { id: 10021, title: 'Compliment', name: 'compliment', category: 'Processes', enabled: true },
              { id: 10022, title: 'Transport', name: 'transport', category: 'Processes', enabled: true },
              { id: 10023, title: 'Keyworker', name: 'keyworker', category: 'Processes', enabled: true },
              { id: 10002, title: 'Visit start', name: 'visit', category: 'Processes', enabled: true },
              { id: 10011, title: 'Visit end', name: 'visit1', category: 'Processes', enabled: true },
              { id: 10004, title: 'Suspended', name: 'suspended', category: 'Processes', enabled: true },
            ],
          }
        ]
      }
    }
  },
  async created() {
    await this.$store.dispatch("getCareAPIParameters");
    this.updateEnabledStatus(this.careSettings, JSON.parse(this.facilityCareAPIParameters[0]?.parameters));
    this.loading = false;
  },
  computed: {
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    facilityCareAPIParameters() {
      return this.$store.state.facilityModule.facilityCareAPIParameters;
    }
  },
  methods: {
    async saveSettings() {
      this.saving = true;
      const filteredData = this.filterDisabledItems(this.careSettings);
      await this.$store.dispatch("updateCareAPIParameters", JSON.stringify(filteredData, null, 2));
      this.saving = false;
    },
    filterDisabledItems(obj) {
      function filterActions(actions) {
        return actions
          .map(action => {
            if (action.actions && Array.isArray(action.actions)) {
              const filteredSubActions = filterActions(action.actions);
              if (action.enabled === false || filteredSubActions.length > 0) {
                return { ...action, actions: filteredSubActions };
              }
              return null;
            }
            return action.enabled === false ? action : null;
          })
          .filter(Boolean);
      }

      const filteredDailyPlan = obj.dailyPlan
        .map(plan => {
          if (plan.actions && Array.isArray(plan.actions)) {
            const filteredActions = filterActions(plan.actions);
            if (plan.enabled === false || filteredActions.length > 0) {
              return { ...plan, actions: filteredActions };
            }
            return null;
          }
          return plan.enabled === false ? plan : null;
        })
        .filter(Boolean);

      const filteredDailyCare = obj.dailyCare
        .map(care => {
          if (care.actions && Array.isArray(care.actions)) {
            const filteredActions = filterActions(care.actions);
            if (care.enabled === false || filteredActions.length > 0) {
              return { ...care, actions: filteredActions };
            }
            return null;
          }
          return care.enabled === false ? care : null;
        })
        .filter(Boolean);

      return {
        dailyPlan: filteredDailyPlan,
        dailyCare: filteredDailyCare
      };
    },
    updateEnabledStatus(originalObj, filteredObj) {
      function updateActions(originalActions, filteredActions) {
        originalActions.forEach(originalAction => {
          const matchingFilteredAction = filteredActions.find(
            filteredAction => filteredAction.name === originalAction.name
          );

          if (matchingFilteredAction) {
            if (matchingFilteredAction.enabled === false) {
              originalAction.enabled = false;
            }

            if (originalAction.actions && matchingFilteredAction.actions) {
              updateActions(originalAction.actions, matchingFilteredAction.actions);
            }
          }
        });
      }

      originalObj.dailyPlan.forEach(originalPlan => {
        const matchingFilteredPlan = filteredObj.dailyPlan.find(
          filteredPlan => filteredPlan.name === originalPlan.name
        );

        if (matchingFilteredPlan) {
          if (matchingFilteredPlan.enabled === false) {
            originalPlan.enabled = false;
          }

          if (originalPlan.actions && matchingFilteredPlan.actions) {
            updateActions(originalPlan.actions, matchingFilteredPlan.actions);
          }
        }
      });

      originalObj.dailyCare.forEach(originalCare => {
        const matchingFilteredCare = filteredObj.dailyCare.find(
          filteredCare => filteredCare.name === originalCare.name
        );

        if (matchingFilteredCare) {
          if (matchingFilteredCare.enabled === false) {
            originalCare.enabled = false;
          }

          if (originalCare.actions && matchingFilteredCare.actions) {
            updateActions(originalCare.actions, matchingFilteredCare.actions);
          }
        }
      });
    },
    updatePlanAndActions(plan) {
      if (plan.actions && Array.isArray(plan.actions)) {
        plan.actions.forEach(action => {
          action.enabled = plan.enabled;
          if (action.actions && Array.isArray(action.actions)) {
            this.updatePlanAndActions(action);
          }
        });
      }
    },
    toggleEnabled(item) {
      this.updatePlanAndActions(item);
    },
  }
}